<template>
    <RouterView />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'

import { mapLocaleToHrefLang } from '@/i18n/helpers'
import { useI18nAddon } from '@/i18n/i18n'

const { currentLocale } = useI18nAddon()

useHead({
    htmlAttrs: {
        class: 'strict-px',
        lang: mapLocaleToHrefLang(currentLocale.value),
        translate: 'no',
    },
})
</script>

<style critical>
@import '@/assets/styles/index.css';

:root {
    --pg-safe-area-top: var(--pg-app-safe-area-top, env(safe-area-inset-top));
    --pg-safe-area-bottom: var(--pg-app-safe-area-bottom, env(safe-area-inset-bottom));
    --pg-safe-area-left: var(--pg-app-safe-area-left, env(safe-area-inset-left));
    --pg-safe-area-right: var(--pg-app-safe-area-right, env(safe-area-inset-right));
}

html {
    touch-action: manipulation;
    -webkit-font-smoothing: antialiased;
}

html.strict-px {
    font-size: 1px;
    --global-right-pannel-width: 0px;
}

@media (width >= 1800px) {
    html.strict-px {
        font-size: calc(100vw / 1800);
    }
}

@media (--desktop-small-plus) {
    html.strict-px {
        --global-right-pannel-width: 300px;
    }
}

body {
    min-height: 100%;
    background-color: var(--carbon-100);
    color: var(--white);
    font-family: var(--font-family);
    scrollbar-gutter: stable;
    overflow-x: clip;
}
</style>
